import { MapData } from '../store/MapData';
import { fromSnapshot } from 'mobx-keystone';

export const createMapDataFromSnapshot = (data: string | object): MapData => {
  const snap = typeof data === 'string' ? JSON.parse(data) : data;
  return fromSnapshot<MapData>(snap);
};
